export class EmailMessageEntity {
    emailTemplateKey;
    emailSerializeObject;
    constructor(emailTemplateKey, emailSerializeObject) {
      this.emailTemplateKey = emailTemplateKey;
      this.emailSerializeObject = emailSerializeObject;
    }
  }
  